/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCapsuleFilled = createReactComponent("filled", "capsule-filled", "IconCapsuleFilled", [["path", { "d": "M12 2l-.243 .004a7.004 7.004 0 0 0 -6.757 6.996v6a7 7 0 0 0 7 7l.243 -.004a7.004 7.004 0 0 0 6.757 -6.996v-6a7 7 0 0 0 -7 -7z", "key": "svg-0" }]]);

export { IconCapsuleFilled as default };
//# sourceMappingURL=IconCapsuleFilled.mjs.map
